import { SideMenuGroup } from '@core/interfaces/entities/side-menu-group.interface';
import { SideMenuGroupDto } from '@core/dtos/side-menu-group.dto';
import { ModuleMapper } from './module.mapper';
import { Mapper } from './mapper';
import { Injectable } from '@angular/core';

/**
 * Mapper para convertir entre la entidad Group de la API
 * y el DTO de SideMenuGroupDto utilizado en el Cliente.
 *
 * @extends {Mapper<Group, SideMenuGroupDto>}
 */
@Injectable({
  providedIn: 'root',
})
export class SideMenuGroupMapper extends Mapper<
  SideMenuGroup,
  SideMenuGroupDto
> {
  constructor(private moduleMapper: ModuleMapper) {
    super();
  }

  /**
   * Mapea un objeto de la entidad 'Group' que proviene de la API
   * a un 'SideMenuGroupDto' para ser usado en el Cliente.
   *
   * @param data El objeto de la entidad 'Group' a mapear.
   * @returns Un Dto de 'SideMenuGroupDto' listo para ser usado en el Cliente.
   */
  mapFrom(data: SideMenuGroup): SideMenuGroupDto {
    return {
      id: data.id,
      icon: data.icon,
      name: data.name,
      order: data.order,
      active: data.active,
      title: data.title,
      labelKey: data.label_key,
      modules: data.modules ? this.moduleMapper.mapFromArray(data.modules) : [],
    };
  }

  /**
   * Mapea un objeto 'SideMenuGroupDto' del Cliente de vuelta
   * a un objeto de la entidad 'Group' para enviar a la API.
   *
   * @param data El Dto de 'SideMenuGroupDto' a mapear.
   * @returns Un objeto de la entidad 'Group' listo para enviar a la API.
   */
  override mapTo(data: SideMenuGroupDto): SideMenuGroup {
    return {
      id: data.id,
      icon: data.icon,
      name: data.name,
      order: data.order,
      active: data.active,
      title: data.title,
      label_key: data.labelKey,
      modules: data.modules ? this.moduleMapper.mapToArray(data.modules) : [],
    };
  }
}
